import { ConfigProvider, Form, Select, TreeSelect } from "antd";

import { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";

const FormSelect = ({
    label = "",
    name = "",
    placeholder = null,
    type = "text",
    size = "middle",
    onChange = () => { },
    className = "",
    subclassName = "",
    required = false,
    options = [],
    vertical = true,
    labelFontSize = "14px",
    fontWeight = "",
    mode = "",
    disabled = false,
    variant = "outlined", //["outlined", "borderless", "filled"]
    allowClear = false,
    onSearch = () => { },
    tree = false,
    maxCount = null,
    multiple = false,
    sortBy = "label",
    disableNonLeaf = false,
    defaultValue = null,
    style = {}
}) => {
    const { t, i18n } = useTranslation();

    const filterOption = (input, option) => {
        console.log("option", option);
        return option?.label?.toLowerCase?.()?.includes?.(input?.toLowerCase?.());
    }

    const getSortedOptions = useCallback((options) => {
        if (!Array.isArray(options)) {
            return [];
        }

        if (sortBy == "none") {
            return options;
        }

        if (sortBy == "value") {
            return [...options]
                .sort((a, b) => {
                    const labelA = String(
                        i18n?.language === 'th'
                            ? a?.value ?? a?.value ?? ''
                            : a?.value ?? a?.value ?? ''
                    );
                    const labelB = String(
                        i18n?.language === 'th'
                            ? b?.value ?? b?.value ?? ''
                            : b?.value ?? b?.value ?? ''
                    );
                    return labelA.localeCompare(labelB, i18n?.language || 'en');
                })
                .map(opt => ({
                    ...opt,
                    label: i18n?.language === 'th'
                        ? opt?.labelTh ?? opt?.label ?? ''
                        : opt?.labelEn ?? opt?.label ?? ''
                }));
        }
        if (sortBy == "null") {
            return options?.map(opt => ({
                ...opt,
                label: i18n?.language === 'th'
                    ? opt?.labelTh ?? opt?.label ?? ''
                    : opt?.labelEn ?? opt?.label ?? ''
            }));
        }

        return [...options]
            .sort((a, b) => {
                const labelA = String(
                    i18n?.language === 'th'
                        ? a?.labelTh ?? a?.label ?? ''
                        : a?.labelEn ?? a?.label ?? ''
                );
                const labelB = String(
                    i18n?.language === 'th'
                        ? b?.labelTh ?? b?.label ?? ''
                        : b?.labelEn ?? b?.label ?? ''
                );
                return labelA.localeCompare(labelB, i18n?.language || 'en');
            })
            .map(opt => ({
                ...opt,
                label: i18n?.language === 'th'
                    ? opt?.labelTh ?? opt?.label ?? ''
                    : opt?.labelEn ?? opt?.label ?? ''
            }));
    }, [i18n.language]);

    const sortedOptions = useMemo(() => getSortedOptions(options), [options, getSortedOptions]);

    const buildTreeDataRecursive = (data, parentCode = null, seen = new Set()) => {
        return data
            .filter(item => (item?.under ? (item?.under?.id || null) : null) === parentCode)
            .map(item => {
                if (seen.has(item.id)) {
                    return null;
                }

                seen.add(item.id);

                const children = buildTreeDataRecursive(data, item.id, seen);

                return {
                    title: i18n.language == 'th' ? item.name : item.nameEn,
                    value: item.id,
                    children: children.length > 0 ? children : undefined,
                    disabled: disableNonLeaf && children.length > 0,
                };
            })
            .filter(item => item !== null);
    };

    const handleChange = (e) => {
        const value = e;
        onChange(value);
    };

    const layout = {
        labelCol: {
            span: 24,
        },
        wrapperCol: {
            span: 24,
        }
    }
    const maxCountFn = useCallback(
        () => {
            // console.log("!maxCount ? {} : { maxCount: { maxCount } }", label, maxCount, !maxCount ? {} : { maxCount: { maxCount } });

            return !maxCount ? {} : { maxCount }
        },
        [maxCount],
    )

    return (
        <ConfigProvider theme={{
            components: {
                Form: {
                    labelFontSize: labelFontSize
                },
            },
        }}>
            <Form.Item
                {...(vertical && layout)}
                label={label}
                labelAlign="left"
                name={name}
                required={required}
                style={{
                    fontWeight: fontWeight,
                    padding: "0px",
                    margin: "0px",
                    ...style
                }}
                rules={[{ required: required, message: i18n.language == 'th' ? 'กรุณาเลือก ${label}' : '${label} is required' }]}
            >
                {tree ? <TreeSelect
                    treeData={buildTreeDataRecursive(sortedOptions)}
                    placeholder={placeholder ?? label}
                    onChange={handleChange}
                    treeDefaultExpandAll={true}
                    size={size}
                    multiple={multiple}
                    allowClear
                    disabled={disabled}
                >
                </TreeSelect> :
                    <Select
                        showSearch
                        variant={variant}
                        required
                        name={name}
                        label={label}
                        filterOption={filterOption}
                        placeholder={placeholder ?? label}
                        size={size}
                        options={sortedOptions}
                        onChange={handleChange}
                        mode={mode}
                        multiple={multiple}
                        disabled={disabled}
                        allowClear={allowClear}
                        onSearch={onSearch}
                        {...maxCountFn()}
                        {...(defaultValue !== null && { defaultValue })}
                    />
                }
            </Form.Item>
        </ConfigProvider>
    );
};

export default FormSelect;
